/** The workspace mode switch's words, in one place. */
export const storyWorkspaceModesCopy = {
  switchLabel: "Workspace mode",
  build: "Build",
  present: "Present",
  explore: "Explore",
} as const;
